export default "__VITE_ASSET__6d052f04__"